// extracted by mini-css-extract-plugin
export default {"infoContainer":"CountryInfo_infoContainer__zlr4r","vector":"CountryInfo_vector__zWyhB","flag":"CountryInfo_flag__xnvCs","infoList":"CountryInfo_infoList__N-MHl"};